import React from 'react'

const NavbarLoader = () => {
  return (
    <div className="header__right d-none d-md-flex" style={{width: "400px"}}>
        <div className="navbar_placeholder" style={{ width: "72px", height: "15px", backgroundColor: "#3C3E4C", borderRadius: "8px" }}></div>
        <div className="navbar_placeholder" style={{ width: "72px", height: "15px", backgroundColor: "#3C3E4C", borderRadius: "8px" }}></div>
        <div className="navbar_placeholder" style={{ width: "56px", height: "15px", backgroundColor: "#3C3E4C", borderRadius: "8px" }}></div>
        <div className='navbar_placeholder' style={{ backgroundColor: "#3C3E4C", width: "40px", height: "40px", borderRadius: "50%" }}></div>
    </div>
  )
}

export default NavbarLoader